<template>
  <div class="container-grid">
    <div class="home1">
      <ToDo sectionTitle="To Do" col="ToDo" />
      <ToDo sectionTitle="Standby" col="Standby" />
     
    </div>
    <div class="home2">
      <ToDo sectionTitle="Done" col="Done" />
    </div>
  </div>
  <div class="container-footer"></div>
  
</template>

<script>
import ToDo from '../components/ToDo.vue'

export default {
  name: 'Home',
  components: { ToDo }
}
</script>

<style>

</style>